import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { CompetitorType } from '..'
import PlayerImage from '../../../../BaseComponents/Image/Player'
import TeamImage from '../../../../BaseComponents/Image/Team'

type Props = {
    imageUrl?: string
    alt?: string
    type: CompetitorType
}

const MatchStatusCompetitorImage: FunctionComponent<Props> = ({ imageUrl, alt, type }) => {
    if (type === 'PLAYER') {
        return <PlayerImage width={20} size="L" imageUrl={imageUrl} alt={alt} />
    }
    return (
        <Grid noExpand width={20} height={20} borderRadius={5} backgroundColor="pearl" center>
            <TeamImage imageUrl={imageUrl} alt={alt} width={14} size="L" />
        </Grid>
    )
}
export default MatchStatusCompetitorImage
